import { Button, Grid, Typography } from '@material-ui/core/';
import withStyles from '@material-ui/core/styles/withStyles';
import React, { useState, useCallback, useMemo } from 'react';
import { ReferenceInput, SelectInput } from 'react-admin';
import DocumentApi from '../../../../core/apis/DocumentApi';
import Confirm from '../../../../core/components/forked/layout/Confirm';
import { useForm } from 'react-final-form';
import red from '@material-ui/core/colors/red';
import useNotifyServerError from '../../../../core/hooks/useNotifyServerError';

const actionBarStyles = () => ({
  selectInput: {
    width: 'auto'
  },
  buttonsContainer: {
    marginTop: '16px'
  },
  button: {
    width: '82px',
    minHeight: '32px',
    height: '30px',
    padding: '0px',
    marginLeft: '5px',
    background: 'white',
    border: '1px solid #E0E0E0',
    '& span': {
      padding: 0
    }
  },
  label: {
    minWidth: '60px',
    marginRight: '5px'
  },
  formHelperText: {
    display: 'none'
  }
});

//action bar component with split select dropdown and Delete button visible after one or more rows are selected
const SplitActionBar = withStyles(actionBarStyles)(props => {
  const {
    resource,
    splitStatus,
    resourceupload,
    selectedRows,
    handleSplit,
    splittedDocuments,
    classes,
    calculateInvestorsWithoutContactsIds
  } = props;
  const [confirmDialogIsOpen, setConfirmDialogIsOpen] = useState(false);

  const form = useForm(props);
  const notifyServerError = useNotifyServerError();

  const hasUnMatchedDocs = useMemo(() => {
    return (
      splittedDocuments.filter(obj => obj.matchingStatus === 'MISMATCH')
        .length > 0
    );
  }, [splittedDocuments]);

  /**
   * Delete selected documents
   */
  const deleteDocuments = useCallback(async () => {
    let documentIdsToDelete = [];
    splittedDocuments.forEach(document => {
      if (document.selected && !document.isFilteredOut) {
        documentIdsToDelete.push(document.id);
      }
    });
    if (documentIdsToDelete.length > 0) {
      const body = documentIdsToDelete.map(documentId => {
        return { documentId: documentId, status: 'DELETED' };
      });

      try {
        await DocumentApi.deleteDocuments(body);
        let changedSplittedDocuments = [...splittedDocuments];
        changedSplittedDocuments = changedSplittedDocuments.filter(
          doc => !documentIdsToDelete.includes(doc.id)
        );
        form.change('splittedDocuments', changedSplittedDocuments);
        //set investor without contacts ids
        calculateInvestorsWithoutContactsIds(changedSplittedDocuments);
      } catch (error) {
        notifyServerError(error);
      }
    }
  }, [
    splittedDocuments,
    form,
    notifyServerError,
    calculateInvestorsWithoutContactsIds
  ]);

  return (
    <Grid
      container
      wrap="nowrap"
      alignItems="center"
      justifyContent="space-between"
      classes={{ container: classes.buttonsContainer }}
    >
      <Grid container item wrap="nowrap" alignItems="center">
        <Typography classes={{ root: classes.label }} variant="caption">
          Split by :
        </Typography>
        <ReferenceInput
          label=""
          source="reSplitMethod"
          reference="splitmethods"
          resource={resource}
          margin="none"
          disabled={
            splitStatus === 'PROCESSING' ||
            splitStatus === '' ||
            splitStatus === 'NONE' ||
            resourceupload.batchStatus === 'A'
          }
          classes={{ input: classes.selectInput }}
        >
          <SelectInput
            optionText="name"
            variant="standard"
            helperText={false}
            FormHelperTextProps={{ classes: { root: classes.formHelperText } }}
          />
        </ReferenceInput>
        <Button
          variant="outlined"
          color="primary"
          disabled={
            splitStatus === 'PROCESSING' ||
            splitStatus === '' ||
            splitStatus === 'NONE' ||
            resourceupload.batchStatus === 'A'
          }
          classes={{ root: classes.button }}
          onClick={handleSplit}
        >
          Re-Split
        </Button>
        {hasUnMatchedDocs && (
          <Typography
            classes={{ root: classes.label }}
            style={{ marginLeft: 'auto', color: red[500] }}
            variant="caption"
          >
            Return to the Investor's record and update the matching field to
            prevent this mismatch during document split.
          </Typography>
        )}
      </Grid>
      {selectedRows.length > 0 && (
        <Grid item>
          <Button
            variant="outlined"
            color="primary"
            classes={{ root: classes.button }}
            onClick={() => setConfirmDialogIsOpen(true)}
          >
            Delete
          </Button>
          <Confirm
            isOpen={confirmDialogIsOpen}
            title="Delete Documents"
            content={
              <div>
                <p>All selected documents will be permanently deleted.</p>
              </div>
            }
            onConfirm={() => {
              deleteDocuments();
              setConfirmDialogIsOpen(false);
            }}
            onClose={() => {
              setConfirmDialogIsOpen(false);
            }}
            confirm="ra.action.confirm"
          />
        </Grid>
      )}
    </Grid>
  );
});

export default SplitActionBar;
